import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import Image from '@components/common/image';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import Colors from '@domain/constant/colors';
import useDebounce from '@utils/hooks/useDebounce';
import { V2Route } from '@utils/routeUtil';

import NumberFormat from '@utils/number/format';
import classnames from 'classnames/bind';
import styles from './title.module.scss';
const cx = classnames.bind(styles);
interface TitleProps {
  positionDetail: PositionDetailVO;
  isWinBackPosition?: boolean;
}

const Title = ({ positionDetail, isWinBackPosition }: TitleProps) => {
  const [isTitleLengthOver, setIsTitleLengthOver] = useState(false);
  const titleEl = useRef<HTMLElement>(null);
  const { companyInfo, basicInfo, additionalInfo } = positionDetail;
  const { salaryText } = basicInfo;

  const companyUrl = V2Route.getCompanyChannelPage(companyInfo.companySn);

  const getJobTitleNameText = () => {
    if (!additionalInfo.jobTitleNames?.length) return `#${additionalInfo.jobGroupName}`;
    const jobTitleName = additionalInfo.jobTitleNames[0];
    const jobTitleNames = additionalInfo.jobTitleNames.map((item, i) => {
      if (i === 0) {
        return `${item}`;
      } else {
        return `, ${item}`;
      }
    });

    if (additionalInfo.jobTitleNames.length === 1) {
      return `#${jobTitleName}`;
    }

    if (additionalInfo.jobTitleNames.length > 1) {
      return (
        <>
          #{jobTitleName}
          <span className={cx('count')}>
            +{additionalInfo.jobTitleNames?.length - 1}
            <div className={cx('tooltip')}>
              <div className={cx('tooltipBox')}>{jobTitleNames}</div>
            </div>
          </span>
        </>
      );
    }

    return '';
  };

  const init = () => {
    setIsTitleLengthOver(getTitleLengthOver());
  };

  // media query length에 따른 positionName 말줄임 기준.
  const getTitleLengthOver = () => {
    if (titleEl.current?.offsetWidth === 648 && basicInfo.positionName.length > 31) return true;
    return false;
  };

  const handleBrowserResize = useDebounce(() => {
    setIsTitleLengthOver(getTitleLengthOver());
  }, 500);

  useEffect(() => {
    init();
    window.addEventListener('resize', handleBrowserResize);
    return () => window.removeEventListener('resize', handleBrowserResize);
  }, []);

  return (
    <>
      <div className={cx('titleArea')}>
        {isWinBackPosition ? (
          <a className={cx('logo', { default: !companyInfo.logoImageUrl })}>
            {companyInfo.logoImageUrl && <Image src={companyInfo.logoImageUrl} alt="logo" width={80} height={80} />}
          </a>
        ) : (
          <Link href={companyUrl} legacyBehavior>
            <a className={cx('logo', { default: !companyInfo.logoImageUrl })} role="button">
              {companyInfo.logoImageUrl && <Image src={companyInfo.logoImageUrl} alt="logo" width={80} height={80} />}
            </a>
          </Link>
        )}
        <div className={cx('titleWrap')}>
          <em className={cx('title')} ref={titleEl}>
            {basicInfo.positionName}
          </em>
          {isTitleLengthOver && <div className={cx('titleModal')}>{basicInfo.positionName}</div>}
          <div className={cx('companyInfoArea')}>
            {isWinBackPosition ? (
              <a className={cx('companyName')}>{companyInfo.companyName}</a>
            ) : (
              <Link href={companyUrl} legacyBehavior>
                <a className={cx('companyName')} role="button">
                  {companyInfo.companyName}
                </a>
              </Link>
            )}
            <span className={cx('companyLocation')}>
              <Icon name="pinLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
              {NumberFormat.formatLocationName(additionalInfo.locationCode)}
            </span>
          </div>
          <div className={cx('companySubInfoArea')}>
            <div className={cx('companySubInfo')}>
              #{basicInfo.recruitmentTypeText}
              {'   '}
              {getJobTitleNameText()}
              {'   '}
              {salaryText}
            </div>
            {/* <div className={cx('viewCount')}>
              조회수 <span className={cx('count')}>{basicInfo.views}</span>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Title;
